/* eslint-disable eqeqeq */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  updateBusiness as updateBusinessApi,
  getBusinessBySellerId as getBusinessBySellerIdApi,
  getBanks,
  getBusinessBySellerId,
} from "../../helpers/backend_helper";
import { Constant } from "utils/enums";
import { getAuthMe } from "live-slices/thunk";

// bank-account-modify

export const updateBussinessBankAccount = createAsyncThunk(
  "business/update",
  async ({ formData, navigate }: { formData: any; navigate: any }, { rejectWithValue }) => {
    try {
      const sellerData = localStorage.getItem(Constant.seller);
      const seller = sellerData ? JSON.parse(sellerData) : {};
      if (seller.accountType == "normal") {
        seller.accountType = "personal";
      }

      seller._id = formData._id;
      seller.idBankDetails = {
        companyLegalName: seller.idBankDetails.companyLegalName,
        businessDocuments: [
          {
            url: seller?.idBankDetails?.businessDocuments[0]?.url,
            metaData: {
              height:  seller?.idBankDetails?.businessDocuments?.metaData?.height,
              width: seller?.idBankDetails?.businessDocuments?.metaData?.width,
              fileType: seller?.idBankDetails?.businessDocuments?.metaData?.fileType,
              fileFormat: seller?.idBankDetails?.businessDocuments?.metaData?.fileFormat,
              name: seller?.idBankDetails?.businessDocuments?.metaData?.name,
              duration: seller?.idBankDetails?.businessDocuments?.metaData?.duration,
            },
          },
        ],
        bankDocuments: [
          {
            url: formData.url,
            metaData: {
              height: seller?.idBankDetails?.bankDocuments?.metaData?.height,
              width: seller?.idBankDetails?.bankDocuments?.metaData?.width,
              fileType: seller?.idBankDetails?.bankDocuments?.metaData?.fileType,
              fileFormat: seller?.idBankDetails?.bankDocuments?.metaData?.fileFormat,
              name: seller?.idBankDetails?.bankDocuments?.metaData?.name,
              duration: seller?.idBankDetails?.bankDocuments?.metaData?.duration,
            },
          },
        ],
        businessAddress: {
          streetAddress: seller?.idBankDetails?.businessAddress?.streetAddress,
          // type: seller?.idBankDetails?.businessAddress?.streetAddress          
          // coordinates: [0],        
          zone: seller?.idBankDetails?.businessAddress?.zone,          
          city: seller?.idBankDetails?.businessAddress?.city,          
          state: seller?.idBankDetails?.businessAddress?.state,          
          stateId: seller?.idBankDetails?.businessAddress?.stateId,       
          cityId: seller?.idBankDetails?.businessAddress?.cityId,        
          zoneId: seller?.idBankDetails?.businessAddress?.zoneId,
          isPlaza: seller?.idBankDetails?.businessAddress?.isPlaza,           
          plazaMarketName: seller?.idBankDetails?.businessAddress?.plazaMarketName,       
          shopName: seller?.idBankDetails?.businessAddress?.shopName,         
          shopNumber: seller?.idBankDetails?.businessAddress?.shopNumber,   
        },
        accountName: formData.accountName,
        accountNumber: formData.accountNumber,
        Iban: formData.Iban,
        bank: formData.bank,
        bankCode: formData.bankCode,
        bankBranch: formData.bankBranch,
        swift: formData.swift,
        isBusinessAddressSame: formData.isBusinessAddressSame,
      };
      const response = await updateBusinessApi(seller);
      if (response && response.data) {
        sessionStorage.setItem(Constant.seller, JSON.stringify(response.data));
      }

      if(response && response.data){
        navigate('/bank-account');
      }

      // toast.success("Business Updated Successfully", { autoClose: 3000 });
      return response.data;
      // history('/my-account-setting');
    } catch (error: any) {
      console.error("Update Error:", error);
      // toast.error("Business Update Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to update business");
    }
  }
);

// business-information-modify
// setting

export const updateBussinessInformation = createAsyncThunk(
  "business/update",
  async ({ formData, navigate }: { formData: any; navigate: any }, { rejectWithValue }) => {
    try {
      const sellerData = localStorage.getItem(Constant.seller);
      const seller = sellerData ? JSON.parse(sellerData) : {};
      let dataToUpdate = { ...seller };
      dataToUpdate.idBankDetails = {
        ...dataToUpdate.idBankDetails,
        ...formData,
      };
      dataToUpdate.idBankDetails.businessAddress = {
        ...dataToUpdate.idBankDetails.businessAddress,
        ...formData.businessAddress,
      };
      dataToUpdate.businessAddress = dataToUpdate.idBankDetails.values.isBusinessAddressSame 
      ? dataToUpdate.address 
      : dataToUpdate.idBankDetails.businessAddress;

      dataToUpdate.sellerType = formData.values.sellerType;
      dataToUpdate.country = formData.values.country;
      dataToUpdate.idBankDetails.companyLegalName = formData.values.companyLegalName;
      dataToUpdate.idBankDetails.isBusinessAddressSame = formData.values.isBusinessAddressSame;
    
      dataToUpdate.idBankDetails.businessRegistrationNumber = formData.values.businessRegistrationNumber;
      dataToUpdate.idBankDetails.isBusinessAddressSame = formData.values.isBusinessAddressSame;
      if (formData.values.cnicNumber) {
        dataToUpdate.nationality = {
          ...dataToUpdate.nationality,
          cnicNumber: formData.values.cnicNumber,
        };
      }

      if (formData.values.personInCharge) {
        if(!dataToUpdate?.personInCharge){

          dataToUpdate = {
            ...dataToUpdate, // Preserve other properties
            personInCharge: {}, // Initialize personInCharge if it doesn't exist
          };
        }
        dataToUpdate.personInCharge ={
          personInCharge: formData.values.personInCharge,
          personInChargeEmail : formData.values.personInChargeEmail,
          personInChargePhoneNumber : "0321"
        }

          delete dataToUpdate.idBankDetails.personInCharge;
      } 
    
      if (formData.values.cnicBackImage) {
        if(!dataToUpdate.nationality.cnicBackImage.url){
          dataToUpdate.nationality.cnicBackImage = {};
        }
        dataToUpdate.nationality.cnicBackImage ={
          url: formData.values.cnicBackImage.url,
        }
      } 

      if (formData.values.cnicFrontImage) {
        if(!dataToUpdate.nationality.cnicFrontImage){
          dataToUpdate.nationality.cnicFrontImage.url = {};
        }
        dataToUpdate.nationality.cnicFrontImage = {
          url: formData.values.cnicFrontImage.url,
      };
      } 
        
        
      

      const response = await updateBusinessApi(dataToUpdate);
      if (response && response.data) {
        localStorage.setItem(Constant.seller, JSON.stringify(response.data));
        navigate("/business-information");
      }


      // toast.success("Business Updated Successfully", { autoClose: 3000 });
      return response.data;
      // history('/my-account-setting');
    } catch (error: any) {
      console.error("Update Error:", error);
      // toast.error("Business Update Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to update business");
    }
  }
);

export const sellerProfileBussinessUpdate = createAsyncThunk(
  "business/update",
  async ({ formData, navigate }: { formData: any; navigate: any },  { rejectWithValue }) => {
    try {

      const formattedTimings = formData.timings.map((timing: any) => ({
        day: timing.day,
        slotsTiming: timing.isOpen
          ? timing.slotsTiming.map((slot: any) => ({
              startTime: slot.startTime,
              endTime: slot.endTime,
            }))
          : [],
        isOpen: timing.isOpen,
      }))


      
      const sellerData = localStorage.getItem(Constant.seller);
      const seller = sellerData ? JSON.parse(sellerData) : {};
      if (seller.accountType == "normal") {
        seller.accountType = "personal";
      }
      seller.firstName = formData.firstName;
      seller.address = formData.address;
      seller.storeName = formData.storeName;
      seller.shopLogo = formData.shopLogo;
      seller.holiday = {
        holidayMode: formData.holidayMode,
        holidayModePeriod: formData.holidayModePeriod,
      };
      seller.timings =  formattedTimings;

      const response = await updateBusinessApi(seller);
      if (response && response.data) { 
        localStorage.setItem(Constant.seller, JSON.stringify(response.data));
      }
      if (response && response.data) {
        navigate("/seller-profile");
      }
      // toast.success("Business Updated Successfully", { autoClose: 3000 });
      return response.data;
    } catch (error: any) {
      console.error("Update Error:", error);
      // toast.error("Business Update Failed", { autoClose: 3000 });
      return rejectWithValue(error.message || "Failed to update business");
    }
  }
);


  export const updateAddress = createAsyncThunk(
    "business/update",
    async ({ formData, navigate }: { formData: any; navigate: any },  { rejectWithValue,dispatch }) => {
      try {
        if (formData.accountType == "normal") {
          formData.accountType = "personal";
        }
        delete formData.idBankDetails;
        delete formData.personInCharge;
        delete formData.holiday

        const response = await updateBusinessApi(formData);
        if (response && response.data) {
          localStorage.setItem(Constant.seller, JSON.stringify(response.data))
          // dispatch(getAuthMe());
        }
        // if (response && response.data) {
        //   // navigate("/business-information");
        //   setTimeout(() => {
        //     if (response && response.data) {
        //       // navigate("/on-boarding", { state: { activeTab: 2 } });
        //     }
        //   }, 2000);

        // }

        return response.data;
      } catch (error: any) {
        console.error("Update Error:", error); // Log error
        // toast.error("Business Update Failed", { autoClose: 3000 });
        return rejectWithValue(error.message || "Failed to update business");

      }  }
);

export const updateBankInformation = createAsyncThunk(
  "business/updateBankinformation",
  async ({ formData, navigate }: { formData: any; navigate: any },  { rejectWithValue,dispatch }) => {
    try {
      // seller.accountType = formData.accountType || "";
      const response = await updateBusinessApi({...formData});
      if (response && response.data) {
        localStorage.setItem(Constant.seller, JSON.stringify(response.data));
        // dispatch(getAuthMe());
        // setTimeout(() => {
        //   if (response && response.data) {
        //     navigate("/on-boarding-two", { state: { activeTab: 4 } });
        //   }
        // }, 2000);
      }
      return response.data;
    } catch (error: any) {
      console.error("Update Error:", error);
      // toast.error("Business Update Failed", { autoClose: 3000 });
      return rejectWithValue("Failed to update business");
    }
  }
);

export const businessBySellerId = createAsyncThunk(
  "business/getBusinessBySellerId",
  async (sellerId: any) => {
    try {
      const response = getBusinessBySellerIdApi(sellerId);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const setSeller = createAsyncThunk(
  "business/update-again",
  (seller:any) => {
    return seller;
  }
)

// export const getBank = createAsyncThunk("business/getBanks", async () => {
//   try {
//     const response = await getBanks();
//     return response.data;
//   } catch (error:any) {
//     return error.message || 'An error occurred';
//   }
// });

export const getBank = createAsyncThunk("business/getBanks", async () => {
  try {
    const response = await getBanks();
    return response.data;
  } catch (error: any) {
    return error.message || "An error occurred";
  }
});


export const getSeller = createAsyncThunk("seller/updated" , async (sellerId: any)  => {
  try {
    const response = await getBusinessBySellerId(sellerId)
    return response.data;
  } catch (error: any) {
    return  error.message || "something wents wrong"
    
  }
})